import { useQuery } from '@hooks/reactQuery';

import { getDashboardAssetsSummary } from '@api/dashboardPO';

import { refetchOptions } from '@constants/common';
import { DASHBOARD_ASSETS_SUMMARY } from '@constants/queryKeys';

const useQueryDashboardAssetsSummary = () => {
	const {
		data: dashboardAssetsSummary,
		isLoading: isLoadingDashboardAssetsSummary,
		isFetching: isFetchingDashboardAssetsSummary,
	} = useQuery({
		queryKey: [DASHBOARD_ASSETS_SUMMARY],
		queryFn: () => getDashboardAssetsSummary(),
		...refetchOptions,
	});

	return {
		dashboardAssetsSummary: dashboardAssetsSummary,
		isLoadingDashboardAssetsSummary: (isLoadingDashboardAssetsSummary && !!dashboardAssetsSummary)
			|| isFetchingDashboardAssetsSummary,
	};
};

export default useQueryDashboardAssetsSummary;
